import React from "react";

function Content() {
  return (
    <div>
      <div className="p-6 text-center">
        <h1 className="font-bold text-2xl border-b-4 border-customOrange inline">
          About
        </h1>
      </div>
    </div>
  );
}

export default Content;
